import _ from 'lodash';

export default function getBulkItemsSellerId(selectedItems) {
	if (
		selectedItems &&
		selectedItems.length > 0 &&
		_.every(selectedItems, item => {
			return item.sellerId == selectedItems[0].sellerId;
		})
	) {
		return selectedItems[0].sellerId;
	}
	return null;
}
